const initState = {
  subtopics: [],
};

const criteriaReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADDED_CRITERIA":
      return {
        ...state,
        addCriteriaSuccess: {
          message: action.message,
          type: "addCriteriaSuccess",
          id: action.id,
        },
      };
    case "ADDED_CRITERIA_ERROR":
      return {
        ...state,
        addCriteriaError: {
          message: action.err.message,
          type: "addCriteriaError",
        },
      };

    case "UPDATED_CRITERIA":
      return {
        ...state,
        updateCriteriaSuccess: {
          message: action.message,
          type: "updateCriteriaSuccess",
        },
      };
    case "UPDATED_CRITERIA_ERROR":
      return {
        ...state,
        updateCriteriaError: {
          message: action.err.message,
          type: "updateCriteriaError",
        },
      };

    case "DELETED_CRITERIA":
      return {
        ...state,
        deleteCriteriaSuccess: {
          message: action.message,
          type: "deleteCriteriaSuccess",
        },
      };

    case "DELETED_CRITERIA_ERROR":
      return {
        ...state,
        deleteCriteriaError: {
          message: action.err.message,
          type: "deleteCriteriaError",
        },
      };

    default:
      return state;
  }
};

export default criteriaReducer;
